import { render, staticRenderFns } from "./TravelInfoTable.vue?vue&type=template&id=ff5294de&scoped=true"
import script from "./TravelInfoTable.vue?vue&type=script&lang=js"
export * from "./TravelInfoTable.vue?vue&type=script&lang=js"
import style0 from "./TravelInfoTable.vue?vue&type=style&index=0&id=ff5294de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5294de",
  null
  
)

export default component.exports